// The cue fields Notes List shows: the number (title), the label text (data.label, sent as `name` since
// 24 Oct 2026) and where the cue sits. A modifyCue write touching any of them sends cue.updated.
const NOTESLIST_CUE_KEYS = ['title', 'label', 'data.label', 'pageNumber', 'x', 'y'];

// eslint-disable-next-line import/prefer-default-export
export function cueWriteNotifiesNotesList(data) {
    return Object.keys(data || {}).some(key =>
        NOTESLIST_CUE_KEYS.includes(key)
        || (key === 'data' && !!data.data && Object.prototype.hasOwnProperty.call(data.data, 'label')));
}


// WEBPACK FOOTER //
// ./src/lib/noteslist-cue-fields.js